import { useEffect, useState } from "react";
import Json from "./output.json";
import {
    MDBRow,
    MDBCol,
    MDBContainer
} from 'mdb-react-ui-kit';
import Card from './Cards';

export default function Content() {
    const [datos, setDatos] = useState([]);

    useEffect(() => {
        // Simulando una carga asíncrona
        // Reemplaza esto con tu lógica de carga de datos real
        // Ejemplo: const response = await fetch("ruta/del/archivo/output.json");
        // const data = await response.json();
        const data = Json; // Simulación de datos, reemplázalo con tu lógica real
        setDatos(Object.values(data));
    }, []);
    return (
        <MDBContainer>
            <br />
            <MDBRow>
                {
                    datos.map((item, index) => (
                        <MDBCol sm={6} lg={3} className='mb-4' key={index}>
                            <Card
                                Id={index}
                                Titulo={item.Titulo}
                                Descripcion={item.Descripcion}
                                Ingredientes={item.Ingredientes}
                                Mezcla={{ 1: "Huevos", 2: "Vainilla", /*...*/ }}
                                Imagen={item.Imagen}
                                Informacion_Adicional={item.Informacion_Adicional}
                                Precio={item.Precio}
                                Precios={{
                                    Vainilla: { 1: "X7:10.000", 2: "X14:19.000", 3: "X30:38.000" },
                                    Chocolate: { 1: "X7:12.000", 2: "X14.20.500", 3: "X30:39.000" },
                                }}
                            />
                        </MDBCol>
                    ))
                }
            </MDBRow>
        </MDBContainer>
    );
}